import { updateToBook } from "../actions";

const updateBook= (todoId, book) => {
    return async (dispatch) => {
        const response = await fetch(`http://localhost:9000/books/${todoId}`, {
            method: "PATCH",
            body: JSON.stringify(book),
            headers: {
                "Content-type": "application/json; charset=UTF-8",
            },
        });
        const todo = await response.json();

        dispatch(updateToBook(todo));
    };
};

export default updateBook;
